/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DueNow/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2Dollar from 'DesignSystem/Svgs/Tysiav2Dollar/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DueNow({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/DueAmounts/Content/DueNow",
  onMouseEnter,
  onMouseLeave,
  isLast,
  hover
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let categoryTypeValueData = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData = 'due_90_days'
let aggregateData = fromAggregate.equals(categoryTypeValueData, constantData)
let categoryTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData1 = 'due_now'
let aggregateData1 = fromAggregate.equals(categoryTypeValueData1, constantData1)
let categoryTypeValueData2 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData2 = 'future_due'
let aggregateData2 = fromAggregate.equals(categoryTypeValueData2, constantData2)
let categoryTypeValueData3 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData3 = 'total_due'
let aggregateData3 = fromAggregate.equals(categoryTypeValueData3, constantData3)
let dtColorsBlue500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.blue.500'
        })
let dtColorsOrange500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.orange.500'
        })
let dtColorsRed500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.500'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let categoryTypeValueData4 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData4 = 'due_30_days'
let aggregateData4 = fromAggregate.equals(categoryTypeValueData4, constantData4)
let categoryTypeValueData5 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData5 = 'due_60_days'
let aggregateData5 = fromAggregate.equals(categoryTypeValueData5, constantData5)
let categoryTypeValueData6 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData6 = 'due_90_days'
let aggregateData6 = fromAggregate.equals(categoryTypeValueData6, constantData6)
let categoryTypeValueData7 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData7 = 'future_due'
let aggregateData7 = fromAggregate.equals(categoryTypeValueData7, constantData7)
let categoryTypeValueData8 = fromData.useDataValue({ viewPath,
context: 'category',
path: 'type',
})
let constantData8 = 'total_due'
let aggregateData8 = fromAggregate.equals(categoryTypeValueData8, constantData8)
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let categoryTotalValueData = fromData.useDataFormat({ viewPath,
context: 'category',
path: 'total',
format: fromFormat.numberMoney,
})
let categoryPaymentAccountsValueData = fromData.useDataFormat({ viewPath,
context: 'category',
path: 'payment_accounts',
format: fromHelpers.getPayorsCount,
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="DueNow.Vertical"
  data-view-path={viewPath}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 style={{'--brw-2-2qCu4e': isLast ? "0px" : "1px",'--brc-3-2qCu4e': isLast ? "transparent" : dtColorsNeutral200,'--bc-1-2qCu4e': hover ? dtColorsNeutral100 : "transparent"}}
 className={`views-block ${styles.Vertical}`}
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="bottom"
 offsetMainAxis={-4}
 hoverTriggerDelay={300}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<div
  data-testid="DueNow.Vertical:1"
  data-view-path={viewPath}
 style={{'--g-4-2qCu4e': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-5-2qCu4e': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-6-2qCu4e': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pl-7-2qCu4e': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="DueNow.Horizontal"
  data-view-path={viewPath}
 style={{'--g-4-2qCu4e': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2Dollar
  viewPath={`${viewPath}/Tysiav2Dollar`}
 height={12}
 width={12}
 fill2={aggregateData ? dtColorsOrange500 : aggregateData1 ? dtColorsRed500 : aggregateData2 ? dtColorsNeutral500 : aggregateData3 ? dtColorsNeutral500 : dtColorsBlue500}
 data={aggregateData ? "category.type" : aggregateData1 ? "category.type" : aggregateData2 ? "category.type" : "category.type"}
 data={aggregateData ? "category.type" : aggregateData1 ? "category.type" : aggregateData2 ? "category.type" : "'due_90_days'"}
 aggregate={aggregateData1 ? "/Data/aggregate.js equals" : aggregateData2 ? "/Data/aggregate.js equals" : aggregateData3 ? "/Data/aggregate.js equals" : "/Data/aggregate.js equals"}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="medium"
 text={aggregateData4 ? "Due >30d" : aggregateData5 ? "Due >60d" : aggregateData6 ? "Due >90d" : aggregateData7 ? "Future due" : aggregateData8 ? "Total due" : "Due now"}
 data={aggregateData4 ? "category.type" : aggregateData5 ? "category.type" : aggregateData6 ? "category.type" : aggregateData7 ? "category.type" : "category.type"}
 data={aggregateData4 ? "category.type" : aggregateData5 ? "category.type" : aggregateData6 ? "category.type" : aggregateData7 ? "category.type" : "'due_30_days'"}
 aggregate={aggregateData5 ? "/Data/aggregate.js equals" : aggregateData6 ? "/Data/aggregate.js equals" : aggregateData7 ? "/Data/aggregate.js equals" : aggregateData8 ? "/Data/aggregate.js equals" : "/Data/aggregate.js equals"}
/>
</div>
<div
  data-testid="DueNow.Horizontal:1"
  data-view-path={viewPath}
 style={{'--g-4-2qCu4e': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="category.total"
 format="/Data/format.js numberMoney"
 text={categoryTotalValueData}
 size="extralarge"
 weight="medium"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="category.payment_accounts"
 format="helpers.js getPayorsCount"
 text={categoryPaymentAccountsValueData}
 size="tiny"
 weight="semibold"
 color={dtColorsNeutral400}
 marginBottom={dtSpaceXxs}
/>
</div>
</div>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
</div>
{children}
</React.Fragment>)
}